import { call, takeEvery } from 'redux-saga/effects';
import { WorkflowConstants } from 'constants/workflowConstants';
import { request } from 'components/Request';

function* checkinAction(action) {
  yield call(request({
    type: WorkflowConstants.CHECKIN_ACTION,
    method: 'POST',
    url: action.payload.url,
    apiUrl: action.payload.apiUrl,
  }), action);
}

function* nextAction(action) {
  yield call(request({
    type: WorkflowConstants.NEXT_ACTION,
    method: 'PUT',
    url: action.payload.url,
  }), action);
}

function* checkPrviousAction(action) {
  yield call(request({
    type: WorkflowConstants.PREVIOUS_ACTION,
    method: 'PUT',
    url: action.payload.url,
  }), action);
}

function* getIPAddress(action) {
  yield call(request({
    type: WorkflowConstants.GET_IP_ADDRESS,
    method: 'GET',
    apiUrl: 'https://ipinfo.io',
  }), action);
}

function* getTestValuesData(action) {
  yield call(request({
    type: WorkflowConstants.GET_TEST_VALUES_DATA,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

const WorkflowSaga = function* () {
  yield takeEvery(WorkflowConstants.CHECKIN_ACTION, checkinAction);
  yield takeEvery(WorkflowConstants.NEXT_ACTION, nextAction);
  yield takeEvery(WorkflowConstants.PREVIOUS_ACTION, checkPrviousAction);
  yield takeEvery(WorkflowConstants.GET_IP_ADDRESS, getIPAddress);
  yield takeEvery(WorkflowConstants.GET_TEST_VALUES_DATA, getTestValuesData);
};

export default WorkflowSaga;
